/**
 * @typedef {Object} StationTypeCreateDto
 * @property {string} stationTypeName
 * @property {string} stationTypeCode
 * @property {string} [description]
 */

/**
 * @typedef {Object} StationTypeUpdateDto
 * @property {string} [stationTypeName]
 * @property {string} [stationTypeCode]
 * @property {string} [description]
 * @property {boolean} [isActive]
 */

/**
 * @typedef {Object} StationTypeResponseDto
 * @property {number} stationTypeId
 * @property {string} stationTypeName
 * @property {string} stationTypeCode
 * @property {string} [description]
 * @property {boolean} isActive
 * @property {string} createdDate
 * @property {string} [createdBy]
 * @property {string} [modifiedDate]
 * @property {string} [modifiedBy]
 */

/**
 * @typedef {Object} StationTypeLookupDto
 * @property {number} stationTypeId
 * @property {string} stationTypeName
 * @property {string} stationTypeCode
 */

const BASE_PATH = 'v1/StationType';

export default function (instance) {
  return {
    getStationTypes(params = {}) {
      return instance.get(BASE_PATH, { params });
    },

    getStationType(id) {
      return instance.get(`${BASE_PATH}/${id}`);
    },

    getLookups() {
      return instance.get(`${BASE_PATH}/lookups`);
    },

    createStationType(payload) {
      return instance.post(BASE_PATH, payload);
    },

    updateStationType(id, payload) {
      return instance.put(`${BASE_PATH}/${id}`, payload);
    },

    deleteStationType(id) {
      return instance.delete(`${BASE_PATH}/${id}`);
    }
  };
}
